import React from 'react';

const SkeletonMetrics = () => {
  return (
    <div className="flex items-center gap-6">
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="h-4 w-28 animate-pulse rounded bg-slate-200 dark:bg-slate-700" />
      ))}
    </div>
  );
};

export default React.memo(SkeletonMetrics);
